import HowItWorks from 'features/payLater/screens/HowItWorks/HowItWorks';

export default function Page() {
  return <HowItWorks />;
}
